<template>
  <div class="isunlock_wrap">
    <div class="title_box" v-if="istitle == 1">
      <div class="title">最新操作</div>

      <div class="text">
        <span class="txt1">AI搜索</span>
        <span class="sp_animation sp_animation1"></span>
        <span class="sp_animation sp_animation2"></span>
        <span class="sp_animation sp_animation3"></span>
        <span class="sp_animation sp_animation4"></span>
        <span class="sp_animation sp_animation5"></span>

        <div class="counter_container">
          <span class="counter_value"
            ><span>{{ currentValue }}</span
            >%</span
          >
        </div>
      </div>
    </div>

    <div class="unlock_box">
      <div class="title">请输入邀请码解锁</div>

      <div class="code">
        <el-input
          v-model="unlockCode"
          style="width: 240px"
          placeholder="请输入邀请码"
          clearable
        />
      </div>

      <div class="btn" @click="subscribe">确认</div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";

export default {
  props: {
    navIndex: 0,
    infoList: {},
    userInfo: {},
  },
  data() {
    return {
      istitle: this.navIndex,
      unlockCode: "",

      currentValue: 0,
      animationSpeed: 50, // 数值变化速度（毫秒）
    };
  },
  created() {},
  mounted() {
    this.startCounter();
  },
  beforeDestroy() {
    this.stopCounter();
  },
  methods: {
    // 0 - 100 循环
    startCounter() {
      this.interval = setInterval(() => {
        this.currentValue++;
        if (this.currentValue > 100) {
          this.currentValue = 0;
        }
      }, this.animationSpeed);
    },
    stopCounter() {
      clearInterval(this.interval);
    },

    // 添加 订阅（解锁）
    subscribe() {
      let data = {
        userNo: this.userInfo.userNo,
        strategyId: this.infoList.id,
        inviteCode: encodeURIComponent(this.unlockCode),
      };

      this.API.CLOUDPost1("quant/api/ai-strategy/subscribe", data).then(
        (res) => {
          // console.log(res);
          if (res.data.code == 200) {
            ElMessage.success("解锁成功");

            location.reload(true);
          } else {
            ElMessage.error(res.data.msg);
          }
        }
      );
    },
  },
  watch: {
    navIndex(newVal) {
      this.istitle = newVal;
    },
  },
};
</script>

<style lang="less" scoped>
.isunlock_wrap {
  .title_box {
    padding-top: 36px;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;

    .text {
      margin-left: 30px;
      padding: 3px 10px;
      background: #28324b;
      display: flex;
      align-items: center;

      .sp_animation {
        width: 3px;
        background: #fff;
        vertical-align: middle;
        display: inline-block;

        &.sp_animation1 {
          margin-left: 36px;
          margin-right: 6px;
          animation: telegraph-animation 1.5s infinite;
          animation-fill-mode: forwards;
        }

        &.sp_animation2 {
          margin-right: 6px;
          animation: telegraph-animation 1.5s infinite 0.2s;
          animation-fill-mode: forwards;
        }

        &.sp_animation3 {
          margin-right: 6px;
          animation: telegraph-animation 1.5s infinite 0.4s;
          animation-fill-mode: forwards;
        }

        &.sp_animation4 {
          margin-right: 6px;
          animation: telegraph-animation 1.5s infinite 0.6s;
          animation-fill-mode: forwards;
        }

        &.sp_animation5 {
          animation: telegraph-animation 1.5s infinite 0.8s;
          animation-fill-mode: forwards;
        }

        @keyframes telegraph-animation {
          0% {
            height: 12px;
          }

          50% {
            height: 0;
          }

          100% {
            height: 12px;
          }
        }
      }

      .counter_container {
        margin-left: 24px;

        .counter_value {
          span {
            display: inline-block;
            width: 32px;
            text-align: right;
          }
        }
      }
    }
  }

  .unlock_box {
    padding: 180px 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-weight: bold;
      font-size: 14px;
    }

    .code {
      margin: 36px 0;
    }

    .btn {
      width: 100px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 16px;
      background: #58aaff;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
</style>